import List from '../components/list.js';
import { useState, useContext, useEffect, useRef } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import { Link } from 'react-router-dom';
import Dialog from '../components/dialog.jsx';
import MerchCard from '../components/merch-card.js'
import { SortableContainer } from '../components/sortable.jsx'
import axios from 'axios';

const MerchList = () => {
    const [merch, setMerch] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const setContext = useContext(Context)[1];
    const { role, metaData } = useContext(AccessContext);
    const [checks, setChecks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [activeMerch, setActiveMerch] = useState([]);
    const [podcastId, setPodcastId] = useState(0);
    const dialogRef = useRef(null);
    setContext('Merch');
    var headings = [
        { key: 'imageUrl', name: 'Image', image: true },
        { key: 'name', name: 'Name', link: true, linkKey: 'id' },
        { key: 'active', name: 'Status', center: true },
        { key: 'priceString', name: 'Price' }
    ];
    if (role == 'Host/Guest') {
        headings = [
            { key: 'imageUrl', name: 'Image', image: true },
            { key: 'name', name: 'Name', link: true, linkKey: 'id' },
            { key: 'priceString', name: 'Price' }
        ];
    }
    useEffect(() => {
        if (role == 'Host/Guest')
            loadMerch();
    }, [role])
    const loadMerch = (page) => {
        setLoading(true);
        if (role == "Host/Guest") {
            axios.post(process.env.REACT_APP_API_URL + 'host', {
                id: metaData.speakerId
            }).then(r => {
                setLoading(false);
                if (r?.data?.status === 'Success') {
                    var filtered = r.data.results.merch.map(res => {
                        if (!res.imageUrl && res?.images?.length > 0) {
                            res.imageUrl = res.images[0];
                        }
                        res.isActive = !!res.active;
                        res.active = res.active ? <span style={{color: 'green'}}>{'\u2714'}</span> : <span style={{color: 'red'}}>{'\u2716'}</span>;
                        res.priceString = '$' + res.price.toFixed(2);
                        return res;
                    }).filter(a => {
                        return a.name.includes(search);
                    });
                    setTotalRecords(filtered.length);
                    setMerch(filtered);
                    console.log(r.data.results.merch);
                    setActiveMerch(r.data.results.merch.map(res => {
                        res.images = !!res.imageJson ? JSON.parse(res.imageJson) : [];
                        if (!!res.imageUrl) res.images.splice(0, 0, res.imageUrl);
                        return res;
                    }));
                }
            });
            return;
        }
        axios.post(process.env.REACT_APP_API_URL + 'merch', {
            page: page,
            search: search
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setTotalRecords(r.data.total);
                setMerch(r.data.results.map(res => {
                    if (!res.imageUrl && res?.images?.length > 0) {
                        res.imageUrl = res.images[0];
                    }
                    res.isActive = !!res.active;
                    res.active = res.active ? <span style={{color: 'green'}}>{'\u2714'}</span> : <span style={{color: 'red'}}>{'\u2716'}</span>;
                    res.priceString = '$' + res.price.toFixed(2);
                    return res;
                }));
                axios.post(process.env.REACT_APP_API_URL + 'podcast').then(r => {
                    if (r?.data?.status === 'Success') {
                        setActiveMerch(r.data.results.merch.map(res => {
                            res.images = !!res.imageJson ? JSON.parse(res.imageJson) : [];
                            if (!!res.imageUrl) res.images.splice(0, 0, res.imageUrl);
                            return res;
                        }));
                        setPodcastId(r.data.results.id);
                    }
                });
            }
        });
    }
    const deleteMerch = () => {
        let toDelete = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.ids.push(merch[i].id);
                acc.urls.push(merch[i].imageUrl);
            }
            return acc
        }, { ids: [], urls: [] });
        if (toDelete.ids.length === 0)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'merch/delete', {
            ids: JSON.stringify(toDelete.ids),
            urls: JSON.stringify(toDelete.urls)
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                loadMerch(currentPage);
                setChecks(Array.apply(null, Array(merch?.length)).map(() => false));
            }
        });
    }
    const addMerchToPodcast = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(merch[i].id);
            }
            return acc
        }, []);
        if (ids.length === 0)
            return;
        setMerch([]);
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'merch/update/podcast-connection', {
            ids: ids,
            add: true
        }).then(r => {
            setLoading(false);
            loadMerch(currentPage);
            setChecks(Array.apply(null, Array(merch?.length)).map(() => false));
        });
    }
    const removeMerchFromPodcast = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(merch[i].id);
            }
            return acc
        }, []);
        if (ids.length === 0)
            return;
        setMerch([]);
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'merch/update/podcast-connection', {
            ids: ids,
            add: false
        }).then(r => {
            setLoading(false);
            loadMerch(currentPage);
            setChecks(Array.apply(null, Array(merch?.length)).map(() => false));
        });
    }
    useEffect(() => {
        loadMerch(0);
    }, []);
    useEffect(() => {
        setChecks(Array.apply(null, Array(merch?.length)).map(() => false));
    }, [merch]);
    const pageSize = 20;
    var pages = [];
    for (var i = Math.max(0, currentPage - 3); i < Math.min(currentPage + 4, Math.ceil(totalRecords / pageSize)); i++) {
        pages.push(i);
    }
    return (
        <main>
            <Dialog ref={dialogRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        dialogRef.current.hide();
                    }}>Close</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        <SortableContainer containerClass="w-100 gap-10 card-container flex" items={activeMerch}
                            onOrderChange={(newList) => {
                                setActiveMerch(newList);
                                axios.post(process.env.REACT_APP_API_URL + 'rank/update', {
                                    ids: JSON.stringify(newList.map(m => m.id)),
                                    ranks: JSON.stringify(newList.map((m, i) => i + 1)),
                                    type: role == 'Host/Guest' ? 'speakermerch' : 'podcastmerch',
                                    id: role == 'Host/Guest' ? undefined : podcastId
                                })
                            }}
                            itemClass="w-100"
                            renderItem={(m, i) => (
                                <MerchCard merch={m} key={i} />
                            )} />
                    </div>
                </div>
            </Dialog>
            <div className="container w-100">
                <div className="form mb-10">
                    <div className="w-100 f-row gap-10">
                        <Link to="/merch" className="btn btn-green">Add Merch</Link>
                    </div>
                    <div className="mw-300 w-100 gap-15 f-row">
                        <button className="link-styles" onClick={deleteMerch}>Delete</button>
                        {role != "Host/Guest" && (
                            <>
                                <button className="link-styles" style={{whiteSpace: 'nowrap'}} onClick={addMerchToPodcast}>Publish</button>
                                <button className="link-styles" style={{whiteSpace: 'nowrap'}} onClick={removeMerchFromPodcast}>Unpublish</button>
                            </>
                        )}
                        <button className="link-styles" style={{whiteSpace: 'nowrap'}} onClick={() => dialogRef.current.show()}>Publish Order</button>
                    </div>
                    {role != "Host/Guest" ? (
                        <div className="ml-auto gap-5 f-row f-end" style={{alignItems: 'center'}}>
                            Product View - 
                            <select className="bare-select">
                                <option>All</option>
                                <option>Published</option>
                                <option>Unpublished</option>
                            </select>
                        </div>
                    ) : <div className="ml-auto gap-5 f-row f-end" style={{alignItems: 'center'}}></div>}
                    <div className="mw-300 w-100 gap-10 f-row f-end">
                        <input type="search" placeholder="Search Merch" value={search} onChange={(e) => setSearch(e.target.value)} />
                        <button className="btn" onClick={() => { setCurrentPage(0); loadMerch(0)}}> Search</button>
                    </div>
                </div>
                <List list={merch} href="merch" actionTitle="Publish" actions={role == "Host/Guest" ? undefined : [{
                    text: (e) => {
                        return !e.isActive ? 'Publish' : 'Unpublish'
                    },
                    action: (e) => {
                        setLoading(true);
                        setMerch([]);
                        axios.post(process.env.REACT_APP_API_URL + 'merch/update/podcast-connection', {
                            ids: [e.id],
                            add: !e.isActive
                        }).then(r => {
                            setLoading(false);
                            loadMerch(currentPage);
                        });
                    }
                }]} headings={headings} loading={loading} onCheck={setChecks} />
                {role != "Host/Guest" && (
                    <div className="list-arrows">
                        {currentPage > 0 && (
                            <button className="btn btn-square btn-arrow" onClick={() => {
                                loadMerch(currentPage - 1);
                                setCurrentPage(c => c - 1);
                            }}>{'\u2039'}</button>
                        )}
                        {pages.map(p => (
                            <button key={p} className={"btn btn-squared" + (p == currentPage ? ' current-page' : '')} onClick={() => {
                                loadMerch(p);
                                setCurrentPage(p);
                            }}>{p + 1}</button>
                        ))}
                        {(currentPage + 1) * pageSize < totalRecords - 1 && (
                            <button className="btn btn-square btn-arrow" onClick={() => {
                                loadMerch(currentPage + 1);
                                setCurrentPage(c => c + 1);
                            }}>{'\u203A'}</button>
                        )}
                    </div>
                )}
            </div>
        </main>
    )
}

export default MerchList;